import { Divider, Link, MenuItem, MenuList } from '@mui/material';
import { ComponentType } from 'react';
import { useTranslation } from 'react-i18next';
import { LinkProps } from 'react-router-dom';
import { Union } from 'ts-toolbelt';

import { EncodedQuery, EncodedQueryProps } from '~/components/EncodedQuery/EncodedQuery';

interface ListCountCellMenuProps {
  list: Union.Nullable<any[]>;
  linkAll?: {
    label: string;
    pathname: string;
    rules: EncodedQueryProps['rules'];
  };
  linkTo?: (id: string) => LinkProps['to'];
  component?: ComponentType<any>;
}

export const ListCountCellMenu = ({ list, linkTo, linkAll, component: Component }: ListCountCellMenuProps) => {
  const { t } = useTranslation();
  return (
    <MenuList disablePadding>
      {linkAll && (
        <EncodedQuery pathname={linkAll.pathname} rules={linkAll.rules}>
          {(linkProps) => <MenuItem {...linkProps}>{t(linkAll.label)}</MenuItem>}
        </EncodedQuery>
      )}
      {linkAll && <Divider />}
      {list &&
        list.map((item: any, index: number) => {
          const linkProps = linkTo && {
            component: Link,
            to: linkTo(item.id),
          };
          return (
            <MenuItem key={index} {...linkProps}>
              {Component ? <Component name={item.name} status={item.status} /> : <span>{item.name}</span>}
            </MenuItem>
          );
        })}
    </MenuList>
  );
};
